import { useState, useEffect } from 'react';
import * as Font from 'expo-font';
import * as SplashScreen from 'expo-splash-screen';

export function useCachedResources() {
	const [isLoadingComplete, setLoadingComplete] = useState(false);

	// Load any resources or data that we need prior to rendering the app
	useEffect(() => {
		async function loadResourcesAndDataAsync() {
			try {
				await SplashScreen.preventAutoHideAsync();

				// Load fonts
				await Font.loadAsync({
					'Poppins-Regular': require('../assets/fonts/Poppins-Regular.ttf'),
					'Poppins-Medium': require('../assets/fonts/Poppins-Medium.ttf'),
					'Poppins-SemiBold': require('../assets/fonts/Poppins-SemiBold.ttf'),
					'Poppins-Bold': require('../assets/fonts/Poppins-Bold.ttf'),
				});
			} catch (e) {
				// We might want to provide this error information to an error reporting service
				console.warn(e);
			} finally {
				setLoadingComplete(true);
				await SplashScreen.hideAsync();
			}
		}

		void loadResourcesAndDataAsync();
	}, []);

	return isLoadingComplete;
}
